import React from "react";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Paper
} from "@mui/material";

const ConfigurationStep = ({ onNext, configValues, setConfigValues }) => {

  const handleTypeChange = (e) => {
    const newType = e.target.value;
    setConfigValues(prev => ({
      ...prev,
      type: newType,
      // update is not supported for trademark — reset to create
      action: newType === "trademark" ? "create" : prev.action
    }));
  };

  const handleActionChange = (e) => {
    setConfigValues(prev => ({
      ...prev,
      action: e.target.value
    }));
  };

  return (
    <Box>

      {/* Content Container */}
      <Paper sx={{ p: 4, background: "#fff" }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Configuration
        </Typography>

        <Typography>Select IP Type</Typography>

        <RadioGroup
          row
          value={configValues.type}
          onChange={handleTypeChange}
        >
          <FormControlLabel value="patent" control={<Radio />} label="Patent" />
          <FormControlLabel value="trademark" control={<Radio />} label="Trademark" />
        </RadioGroup>

        <Typography sx={{ mt: 3 }}>Action Type</Typography>

        <RadioGroup
          row
          value={configValues.action}
          onChange={handleActionChange}
        >
          <FormControlLabel value="create" control={<Radio />} label="Matter Creation" />
          <FormControlLabel
            value="update"
            control={<Radio />}
            label="Matter Update"
            disabled={configValues.type === "trademark"}
          />
        </RadioGroup>
      </Paper>

      {/* Footer Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button variant="contained" onClick={onNext}>
          Continue
        </Button>
      </Box>

    </Box>
  );
};

export default ConfigurationStep;